module.exports = __webpack_public_path__ + "static/media/A2_06.79ff6376.png";